import { render, staticRenderFns } from "./navigation-phone.vue?vue&type=template&id=48b80f1e&scoped=true&"
import script from "./navigation-phone.vue?vue&type=script&lang=ts&"
export * from "./navigation-phone.vue?vue&type=script&lang=ts&"
import style0 from "./navigation-phone.vue?vue&type=style&index=0&id=48b80f1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b80f1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
